import { useObrasListaTable } from "./use-obras-lista-table";
import { ObrasListaTableView } from "./view-obras-lista-table";
import type { ObrasListaTableItem, ObrasListaTableProps } from "./types-obras-lista-table";

/**
 * Tabela da Lista de obras (Figma 11161:217296 e Financeiro 12760:969941): `HubTable` com ordenação por cabeçalho no
 * servidor, colunas fixas (ID, Embarcação e lupa) e a coluna Obra do mobile. A tela entrega o catálogo de colunas, as
 * larguras e o conteúdo das células; o cartão, as medidas e o scss são os mesmos para Obras e Financeiro.
 */
export function ObrasListaTable<T extends ObrasListaTableItem, K extends string, S extends string>(
  props: ObrasListaTableProps<T, K, S>,
) {
  const vm = useObrasListaTable(props);

  return <ObrasListaTableView {...vm} />;
}

export {
  OBRAS_LISTA_TABLE_DETAIL_KEY,
  OBRAS_LISTA_TABLE_EMBARCACAO_KEY,
  OBRAS_LISTA_TABLE_ID_KEY,
} from "./obras-lista-table.constants";
export type * from "./types-obras-lista-table";
